var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"是否可见"}},[_c('el-switch',{model:{value:(_vm.data.display),callback:function ($$v) {_vm.$set(_vm.data, "display", $$v)},expression:"data.display"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }